import React from 'react'
import PropTypes from 'prop-types'
import Error from './form-input-error'
import { FormattedMessage } from 'react-intl'

import Text from '../label'

//https://hacker0x01.github.io/react-datepicker/
class Select extends React.Component {
    static propTypes = {
        label: PropTypes.string,
        value: PropTypes.string,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.oneOfType([
                    PropTypes.string.isRequired,
                    PropTypes.number.isRequired
                ]).isRequired,
                value: PropTypes.string.isRequired
            })
        ).isRequired,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        placeholder: PropTypes.string,
        errorStr: PropTypes.string,
        onChange: PropTypes.func
    }
    static defaultProps = {
        errorStr: 'app.error',
        value: ''
    }

    state = {
        value: this.props.value
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState(nextProps)
    }

    onChange({target: {value}}) {
        if(!this.props.onChange) {
            return this.update({value})
        }
        let promise = this.props.onChange(value) || Promise.resolve(value)
        !promise._state && this.update({loading: true})
        promise.then(() => setTimeout(() => this.update({value}), 10)).catch(e => this.update({error: true}));
    }

    update = ({loading=false, error= false, value=this.state.value}) => {
        this.setState({loading, error, value})
    }

    select(selected) {
        const {disabled=false, options=[]} = this.props;
        const {loading=false} = this.state;

        return <select onChange={this.onChange.bind(this)} value={selected} disabled={disabled || loading}>
            {options.map((opt) =>
                <FormattedMessage id={opt.value} key={'select-' + opt.id}>
                    {message => <option value={opt.id} disabled={loading}>{message}</option>}
                </FormattedMessage>
            )}
        </select>
    }

    render() {
        const {label, errorStr} = this.props;
        const {error=false, value} = this.state;
        let {className=false} = this.props;

        className = 'form form-select' + (className ? ' ' + className : '')

        return <div className={className} >
            <Text>{label}</Text>:
            <div className={'form-values' + (error?' error':'')}>
                {this.select(value)}
                <Error visible={error} message={errorStr} />
            </div>
        </div>
    }
}

export default Select
